import type { KeyboardEvent } from 'react';

/** Arrow keys, Home and End move focus between the links in `list`. */
export function handleLinkListNavigation(
  event: KeyboardEvent<HTMLElement>,
  list: HTMLElement | null,
) {
  const links = Array.from(list?.querySelectorAll<HTMLAnchorElement>('a[href]') ?? []);
  if (links.length === 0) {
    return;
  }
  let index = links.findIndex((link) => link === document.activeElement);
  switch (event.key) {
    case 'ArrowDown':
      index = Math.min(index + 1, links.length - 1);
      break;
    case 'ArrowUp':
      index = index < 0 ? links.length - 1 : Math.max(index - 1, 0);
      break;
    case 'Home':
      index = 0;
      break;
    case 'End':
      index = links.length - 1;
      break;
    default:
      return;
  }
  // Move actual focus so Enter always opens the highlighted link.
  event.preventDefault();
  links[index]?.focus();
}
